import { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./ModalInformacion.css";
import { Contexto } from "@Componentes/App";
import * as _f_ from "@Funciones/funciones";

function ModalInformacion({ titulo, children, respuesta, fCerrar, estilos, vBotonCerrar=true }) {
  const ultimoToque = useRef(0); //ANDROID
  const navigate = useNavigate();
  const referenciaModal = useRef(null);
  const { cv_u, ecv_u, esComputadora } = useContext(Contexto);
  const [posicion, setPosicion] = useState({
    xPorcentaje: 0.5,
    yPorcentaje: 0.5,
  });

  const arrastrando = useRef(false);
  const desplazamiento = useRef({ x: 0, y: 0 });

  useEffect(() => {
    console.log(respuesta)
    centrarModal();
  }, []);

  useEffect(() => {
    const manejarResize = () => {
      setPosicion((prev) => ({ ...prev }));
    };

    window.addEventListener("resize", manejarResize);
    return () => window.removeEventListener("resize", manejarResize);
  }, []);

  const centrarModal = () => {
    const modal = referenciaModal.current;
    const rect = modal.getBoundingClientRect();

    const centroX =
      (window.innerWidth / 2 - rect.width / 2) / window.innerWidth;

    const centroY =
      (window.innerHeight / 2 - rect.height / 2) / window.innerHeight;

    setPosicion({ xPorcentaje: centroX, yPorcentaje: centroY });
  };

  const manejarMouseDown = (e) => {
    arrastrando.current = true;

    const rect = referenciaModal.current.getBoundingClientRect();

    desplazamiento.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  };

  const manejarMouseMove = (e) => {
    if (!arrastrando.current) return;

    const nuevoX = (e.clientX - desplazamiento.current.x) / window.innerWidth;

    const nuevoY = (e.clientY - desplazamiento.current.y) / window.innerHeight;

    setPosicion({
      xPorcentaje: nuevoX,
      yPorcentaje: nuevoY,
    });
  };

  const manejarMouseUp = () => {
    arrastrando.current = false;
  };

  const estiloModal = {
    left: posicion.xPorcentaje * window.innerWidth,
    top: posicion.yPorcentaje * window.innerHeight,
  };
  //ANDROID
  const manejarDobleToque = () => {
    const ahora = Date.now();
    if (ahora - ultimoToque.current < 300) {
      // 300ms entre toques
      centrarModal(); // llama tu función de centrar
    }
    ultimoToque.current = ahora;
  };

  const cerrraModal = () => {
    //ecv_u({ contenido: false, visible: false });
    _f_.asignar(ecv_u, { visible: false },true,"ModalInformacion");
    //console.log(respuesta);
    if (respuesta && respuesta.error) {
      if (respuesta?.contenido?.SMListaErrores instanceof Array) {
        for (let temp of respuesta.contenido?.SMListaErrores) {
          if ([9999, 9998].includes(temp?.codError)) {
            _f_.eliminarCookies();
            //navigate("/");
            window.location.href = "/";
            window.location.replace("/");
          }
        }
      }
    }

    fCerrar?.();
  };

  return (
    <div
      id="modal-Info"
      escomputadora={String(esComputadora)}
      onMouseMove={manejarMouseMove}
      onMouseUp={manejarMouseUp}
      style={_f_.estilosObjetoVariablesCSS(estilos)}
    >
      <div
        ref={referenciaModal}
        className="modal-contenido"
        style={estiloModal}
      >
        <div
          className="modal-header"
          onMouseDown={manejarMouseDown}
          onDoubleClick={centrarModal}
          //ANDROID
          //ANDROID
          onTouchStart={(e) => manejarMouseDown(e.touches[0])}
          onTouchMove={(e) => manejarMouseMove(e.touches[0])}
          onTouchEnd={manejarMouseUp}
        >
          {titulo ? titulo : "Titulo"}
        </div>

        {vBotonCerrar && <span id="modal-btn-cerrar" onClick={cerrraModal}>
          &times;
        </span>}

        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

export default ModalInformacion;
